import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IPurchaseInvoiceStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IPurchaseInvoiceStatsResponse>,
  IPathBaseParam,
  object
>("stores.purchaseInvoices.stats");

export const stats = {
  ...getApis,
};
